import styled from 'styled-components';

const AppMain = styled.main`
  grid-area: main;
  overflow: auto;
`;

export const Styled = { AppMain };
